import React, { useMemo, useState } from "react";
import * as Scrivito from "scrivito";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import NiceModal from "@ebay/nice-modal-react";
import cx from "classnames";
import { items } from "variables";
import {
  useFetchScrivitoDocumentsForProduct,
  useTranslate,
  useUpdatedItemsForProductDownload,
} from "hooks";
import { ProductReportsDownloadButtonsBlock } from "../../ProductReportsDownloadButtonsBlock";
import { ModalCheckboxesBlock } from "./ModalCheckboxesBlock";
import s from "./ProjectDownloadModal.module.scss";

export const SingleProductDownloadModal = NiceModal.create(
  Scrivito.connect(({ modalSubtitle, orderCode, presentation, nodeId }) => {
    const translate = useTranslate();
    const modal = NiceModal.useModal();
    if (!orderCode) {
      return null;
    }

    const { documents } = useFetchScrivitoDocumentsForProduct({
      seriesId: orderCode?.seriesId,
    });

    const [itemsData, setItemsData] = useState(items);
    const [expandedAccordionIds, setExpandedAccordionIds] = useState([]);

    useUpdatedItemsForProductDownload({
      documents,
      presentation,
      setItemsData,
    });

    // TODO (25.11.25): nodeId is an exception because LCA reports can only be downloaded with it (Makersite logic); "de" because it currently works only in German.
    const filteredItems = useMemo(
      () =>
        // !nodeId || lang !== "de"
        //   ? itemsData.filter((i) => i.id !== "LCA_REPORT")
        //   : itemsData,
        // TODO (01.12.25) LCA Report should be hidden since we still didn't get any Information from Makersite (Task 62880). Remove it and uncomment when Makersite will finish their part; add lang in the component props
        itemsData.filter((i) => i.id !== "LCA_REPORT"),
      [itemsData],
    );

    return (
      <Modal
        isOpen={modal.visible}
        centered={true}
        size="xl"
        toggle={modal.remove}
        scrollable={true}
      >
        <ModalHeader
          toggle={modal.remove}
          tag="div"
          className="d-flex align-items-start pb-0"
        >
          <h3 className="text-uppercase my-xxl-1 lh-32">
            {translate("DOWNLOAD_OPTIONS")}
          </h3>
          <h4 className="mb-0 lh-24">{modalSubtitle}</h4>
        </ModalHeader>
        <ModalBody
          className={cx("d-flex row pb-8 pt-xs-6 ", s.modalBodyScrollbar)}
        >
          <ModalCheckboxesBlock
            itemsData={filteredItems}
            setItemsData={setItemsData}
            blockTitle=""
            showProducts={false}
            seriesId={orderCode?.seriesId.toString()}
            expandedAccordionIds={expandedAccordionIds}
            setExpandedAccordionIds={setExpandedAccordionIds}
          />
        </ModalBody>
        <ModalFooter className="pt-0">
          <ProductReportsDownloadButtonsBlock
            nodeId={nodeId}
            itemsData={filteredItems}
            setItemsData={setItemsData}
            documents={documents}
            orderCode={orderCode}
            setExpandedAccordionIds={setExpandedAccordionIds}
          />
        </ModalFooter>
      </Modal>
    );
  }),
);
